import { motion } from 'framer-motion';
import { WordReveal } from '@/components/ui/word-reveal';

export function KeyNumbers() {
  const stats = [
    {
      value: '1000+',
      label: 'Businesses Supported',
      icon: (
        <svg
          className="w-6 h-6 text-emerald-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
          />
        </svg>
      ),
    },
    {
      value: '100+',
      label: 'Verified Associates',
      icon: (
        <svg
          className="w-6 h-6 text-emerald-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          />
        </svg>
      ),
    },
    {
      value: '98%',
      label: 'Client Satisfaction',
      icon: (
        <svg
          className="w-6 h-6 text-emerald-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
          />
        </svg>
      ),
    },
    {
      value: '24/7',
      label: 'Support',
      icon: (
        <svg
          className="w-6 h-6 text-emerald-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
    },
  ];

  return (
    <section className="relative bg-[#041a10] text-white py-16 md:py-20 overflow-hidden border-y border-emerald-900/60">
      {/* Subtle background glow */}
      <div className="pointer-events-none absolute -left-20 top-1/2 -translate-y-1/2 h-80 w-80 rounded-full bg-emerald-500/10 blur-[100px]" />
      <div className="pointer-events-none absolute -right-20 top-1/2 -translate-y-1/2 h-80 w-80 rounded-full bg-teal-400/10 blur-[100px]" />

      <div className="relative z-10 mx-auto w-full max-w-7xl 2xl:max-w-[1400px] px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4 space-y-2">
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-emerald-400">
              KEY NUMBERS
            </span>
            <WordReveal
              as="h2"
              text="Trusted by businesses across India"
              highlightWords={['India']}
              highlightClassName="text-emerald-400 font-extrabold"
              className="font-display text-2xl font-extrabold tracking-tight sm:text-3xl text-white leading-tight"
              stagger={0.06}
            />
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 gap-4 sm:gap-6 sm:grid-cols-4">
            {stats.map((s, idx) => (
              <motion.div
                key={s.label}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: idx * 0.1, ease: [0.16, 1, 0.3, 1] }}
                className="group relative rounded-xl border border-emerald-800/40 bg-emerald-950/40 p-4 sm:p-5 backdrop-blur-md hover:border-emerald-500/50 hover:bg-emerald-900/40 transition-all duration-300"
              >
                <div className="space-y-2">
                  <div className="flex items-center gap-2.5">
                    {s.icon}
                    <span className="font-display text-2xl sm:text-3xl font-black text-white tracking-tight group-hover:text-emerald-300 transition-colors">
                      {s.value}
                    </span>
                  </div>
                  <p className="text-xs text-gray-300 font-medium">{s.label}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
